import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Message } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastBehaviorSubjectService {

  public changeOccured: BehaviorSubject<Message> = new BehaviorSubject<Message>({});

  constructor() { 

  }

  show(message: Message): void {
      this.changeOccured.next(message);
  }
  
}
